
let styles = {
  container: {
    padding: '3%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: 'white',
    padding: '1%',
  },

  items: {
    paddingLeft: '1%',
    paddingRight:'1%',
    paddingTop:'1%',
    display:'flex',
    flexDirection:'row'
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '15%',
    width:'50%'
  },

  item_body: {
    padding: '1px ',
    width:'80%',
    backgroundColor:'#ddd',
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#84DCF2',
    marginTop:'5px'
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '80%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addCompetitionExpense/style.js